import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showing: false,
  triggerSearch: false,
};

const radeSlice = createSlice({
  name: 'radeSlice',
  initialState,
  reducers: {
    show(state) {
      state.showing = true;
      state.triggerSearch = !state.triggerSearch;
    },
    hide(state) {
      state.showing = false;
    },
  },
});

export const { show, hide } = radeSlice.actions;
export default radeSlice.reducer;
